<template>
  <messenger-popover-layout>
    <div class="text-center">
      <div class="survey-title">{{ $t('chat.howWasTheHelpYouReceived') }}</div>

      <div class="neutral--text lh-20 mb-8">
        {{ $t('chat.weAreAlwaysStrivingToImprove') }}
      </div>

      <div class="d-flex align-center gap-12 justify-center mb-8">
        <widget-circle-button
          color="green"
          :is-loading="sending === 'good'"
          :is-disabled="!!sending && sending !== 'good'"
          @click="rateChat('good')"
        >
          <widget-icon
            name="thumb_up"
            size="36px"
          />
        </widget-circle-button>

        <widget-circle-button
          color="red"
          :is-loading="sending === 'poor'"
          :is-disabled="!!sending && sending !== 'poor'"
          @click="rateChat('poor')"
        >
          <widget-icon
            name="thumb_down"
            size="36px"
          />
        </widget-circle-button>
      </div>

      <widget-link
        size="12"
        variant="secondary"
        @click="onSkip()"
      >
        {{ $t('chat.skipForNow') }}
      </widget-link>
    </div>
  </messenger-popover-layout>
</template>

<script setup lang="ts">
import MessengerPopoverLayout from '@widgets/messenger/components/popovers/MessengerPopoverLayout.vue'
import type { Popovers } from '@widgets/messenger/types/popover'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import type { MessengerChatRate } from '@widgets/messenger/types/chat/chat'
import WidgetCircleButton from '@widgets/shared/components/WidgetCircleButton.vue'
import WidgetLink from '@widgets/shared/components/WidgetLink.vue'
import { ref } from '@/composition/vue/compositionApi'

const props = defineProps<Popovers['satisfactionSurveyRate']>()

const sending = ref<MessengerChatRate | null>(null)

const rateChat = async (rate: MessengerChatRate) => {
  sending.value = rate
  try {
    await props.onRate(rate)
  } finally {
    sending.value = null
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.survey-title {
  font-size: 20px;
  line-height: 24px;
  font-weight: $bold-font;
  margin-bottom: 8px;
}
</style>
